module.exports = __webpack_public_path__ + "static/media/feature6.43cf8aa1.png";